<template>
  <div class="resource_modal">
    <div class="header_text resource_header" style="margin: 20px 0;">
      Click the link to view {{getType}}(s):
    </div>
    <div v-if="getList.length > 0">
      <div class="resource_list" v-for="(l, i) in getList" :key="i">
        <div class="resource_name">{{l.title}}</div>
        <div class="resource_name"><a :href="l.link" target="_blank">Download / View</a></div>
      </div>
    </div>
    <div v-else>
      <div class="resource_list">
        <div class="resource_name">No data found!</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props:["list", "category"],
  computed: {
    getList() {
      return this.list.filter(o => o.type == this.category) || []
    },
    getType() {
      return this.category
    }
  }
}
</script>

<style>
/*modal starts*/
.resource_modal {
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-top: -20px;
  max-width: 300px;
}
.resource_list {
  display: flex;
  justify-content: space-between;
  height: 100%;
}
.resource_name {
  margin: 10px 10px;
  font: normal normal normal 14px/29px Open Sans;
  color: #728391;
}
.resource_header {
  background: #013686 0% 0% no-repeat padding-box;
  padding: 20px;
  color: white;
}
/*modal ends*/
</style>